<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getAiAssistantList()"
          variant="primary"
          size="sm"
        )

  .card-body
    .row
      .col-md-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="10%")
                  span(:title="$t('ui.en_name')") {{ $t("ui.en_name") }}
                th(width="10%")
                  span(:title="$t('ui.cn_name')") {{ $t("ui.cn_name") }}
                th(width="10%")
                  span(:title="$t('ui.local_name')") {{ $t("ui.local_name") }}
                th(width="10%")
                  span(:title="$t('ui.img_small')") {{ $t("ui.img_small") }}
                th(width="10%")
                  span(:title="$t('ui.img_large')") {{ $t("ui.img_large") }}
                th.text-center(width="7%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="10%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
            tbody.clusterize-content
              tr(v-if="aiAssistantList.length == 0")
                td(colspan="8").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in aiAssistantList")
                td.text-center
                  span(:title="index + 1") {{ index + 1 }}
                td
                  span.small(:title="item.en_name") {{ item.en_name }}
                td
                  span.small(:title="item.cn_name") {{ item.cn_name }}
                td
                  span.small(:title="item.local_name") {{ item.local_name }}
                td
                  span(v-if="item.img_url_small")
                    b-img.fiximg(:src="imagePath + item.img_url_small" @error="handleImageError")
                td
                  span(v-if="item.img_url_large")
                    b-img.fiximg(:src="imagePath + item.img_url_large" @error="handleImageError")
                td
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="!isEditAccess ? null : changeAiAssistantStatus(item, $event)" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.actions.text-center(v-if="isEditAccess")
                  span.mr-1
                    a.fa.fa-edit.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                td.text-right
                  template(v-if="item.modified_date")
                    .d-block(:title="item.modified_by") {{ item.modified_by }}
                    .d-block(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                  template(v-else)
                    span -

    editaiassistant(ref="editaiassistant" :item="editSelectedAiAssistant" @clicked="afterUpdateAiAssistant" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import editaiassistant from "@/components/cms/editAiAssistant.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editaiassistant,
  },
  data: () => ({
    loading: false,
    aiAssistantList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedAiAssistant: null,
    imagePath: config.viewImageUrl
  }),
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_aiassistant");
    }
  },
  mounted: function() {},
  methods: {
    refresh() {
      this.getAiAssistantList()
    },
    handleImageError(event) {
      event.target.src = 'https://placehold.co/150?text=No+Image'; // Set fallback image
    },
    onEdit(e) {
      this.editSelectedAiAssistant = e;
      this.$refs.editaiassistant.$refs.editAiAssistant.show();
    },
    afterUpdateAiAssistant: function() {
      this.getAiAssistantList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_ai_assistant"), this.$t("message.success"), "success");
    },
    getAiAssistantList: function() {
      let url = config.aiAssistantGetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.aiAssistantList = response.data.dt;
                this.editSelectedAiAssistant = null
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changeAiAssistantStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_ai_assistant_status_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmAiAssistantStatus(eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmAiAssistantStatus: function(status) {
      let url = config.aiAssistantStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getAiAssistantList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getAiAssistantList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>